const languagesItems = [
  {
    id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    code: "SERBIAN",
    label: "Srpski",
  },
  {
    id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    code: "ENGLISH",
    label: "Engleski",
  },
];

export default languagesItems;
